import * as React from "react";
import { NavLinks } from "NavLinks";

export function TermsPage(): React.ReactNode {
  const lastUpdated = "January 23, 2026";

  return (
    <div className="w-full h-vh flex flex-col px-4 lg:px-0">
      <div className="flex justify-center items-center">
        <NavLinks location="header" />
      </div>

      <div className="w-full flex justify-center">
        <div className="w-full max-w-5xl py-8 px-4 md:px-8">
          <div className="w-full max-w-2xl text-[16px] md:text-[18px] text-zinc-400/75 flex flex-col space-y-5 leading-[26px] md:leading-[31px] md:pt-8">
            <span className="text-zinc-700 select-none font-medium text-[11px] uppercase">Legal</span>

            <h1 className="!mt-4 text-[30px] md:text-[42px] text-zinc-100 font-semibold leading-[47px] md:leading-[64px]">Terms of Service</h1>

            <p className="text-zinc-500 text-sm">Last updated: {lastUpdated}</p>

            <span />

            <p>
              By accessing or using Subtrace (&ldquo;Subtrace&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;), available at{" "}
              <a href="https://subtrace.dev" rel="noreferrer" target="_blank" className="text-zinc-400/80 hover:text-zinc-400 underline">
                https://subtrace.dev
              </a>{" "}
              (the &ldquo;Service&rdquo;), you agree to these Terms.
            </p>

            <h2 id="the-service" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              1. The Service
            </h2>
            <p>
              Subtrace provides developer tooling for inspecting and understanding application and network behavior. The Service is provided on an &ldquo;as-is&rdquo; and
              &ldquo;as-available&rdquo; basis.
            </p>

            <h2 id="accounts" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              2. Accounts
            </h2>
            <p>You are responsible for maintaining the security of your account and for all activity that occurs under it.</p>

            <h2 id="customer-data" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              3. Customer Data
            </h2>
            <p>You retain ownership of any data you submit to the Service (&ldquo;Customer Data&rdquo;). You represent that you have the right to provide Customer Data to us.</p>
            <p>We process Customer Data only to operate, maintain, and improve the Service. We do not sell Customer Data.</p>

            <h2 id="security" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              4. Security
            </h2>
            <p>We take reasonable administrative, technical, and organizational measures to protect Customer Data, including:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Restricting access to authorized personnel</li>
              <li>Encrypting data in transit using TLS</li>
              <li>Encrypting sensitive data at rest where applicable</li>
            </ul>
            <p>We maintain an incident response process and will notify customers of security incidents affecting their data as required by law or contract.</p>

            <h2 id="acceptable-use" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              5. Acceptable Use
            </h2>
            <p>You agree not to misuse the Service, violate applicable laws, interfere with the Service, or attempt unauthorized access.</p>

            <h2 id="termination" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              6. Termination
            </h2>
            <p>
              You may stop using the Service at any time. We may suspend or terminate access if you violate these Terms or use the Service in a way that poses security or legal
              risk.
            </p>

            <h2 id="disclaimers" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              7. Disclaimers
            </h2>
            <p>The Service is provided &ldquo;as is&rdquo; without warranties of any kind.</p>

            <h2 id="limitation-of-liability" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              8. Limitation of Liability
            </h2>
            <p>To the maximum extent permitted by law, Subtrace is not liable for indirect, incidental, or consequential damages arising from your use of the Service.</p>

            <h2 id="changes" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              9. Changes
            </h2>
            <p>We may update these Terms from time to time. Continued use of the Service after changes take effect constitutes acceptance of the updated Terms.</p>

            <h2 id="contact" className="!mt-12 mb-8 text-[24px] text-zinc-300 font-semibold">
              10. Contact
            </h2>
            <p>
              Questions or security issues may be reported to{" "}
              <a href="mailto:security@subtrace.dev" className="text-zinc-400/80 hover:text-zinc-400 underline">
                security@subtrace.dev
              </a>
              .
            </p>
          </div>
        </div>
      </div>

      <div className="mt-24 flex justify-center items-center">
        <NavLinks location="footer" />
      </div>
    </div>
  );
}
